// extracted by mini-css-extract-plugin
export default {"wrapper":"FormItem_wrapper__u3fAx","half":"FormItem_half__Dt1bY","noMargin":"FormItem_noMargin__DELNb"};